import { pushRetryableEvent } from "./utils";

export default InfiniteScrollBottom = {
    loadMore(entries) {
        if (entries[0].isIntersecting) {
            pushRetryableEvent(this, "load_more_at_bottom");
        }
    },
    mounted() {
        const scrollBody = document.getElementById("infinite-scroll-body");
        this.observer = new IntersectionObserver(
            (entries) => this.loadMore(entries),
            {
                root: scrollBody, // window by default
                rootMargin: "400px",
                threshold: 0.1,
            }
        );
        this.observer.observe(this.el);
    },
    destroyed() {
        this.observer.unobserve(this.el);
    },
};
